module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-DemiLight.069d05f.woff";